/* global setupVideoPlayer */
const playerSelector = '.video-player';

export class VideoInline {
  static isOnPage() {
    return $(playerSelector).length !== 0;
  }

  constructor() {
    this.init();
  }

  init() {
    $.each($(playerSelector), (index, player) => {
      const $player = $(player);

      if ($player.data('video-player-initialized')) {
        return;
      }
      const playerId = $player.attr('id') || `video-player-${index}`;

      if (!$player.attr('id')) {
        $player.attr('id', playerId);
      }

      const videoUrlHls = $player.data('video-url-hls');
      const videoUrlProgressive = $player.data('video-url-progressive');
      const $container = $player.closest('.inline-video-container');
      const $bgImage = $container.find('.video-player-bg-image');
      const srcset = $bgImage.data('srcset');
      const posterImage = srcset ? srcset.split(',')[0].trim().split(' ')[0] : '';
      const videoName = $player.data('video-name') || '';
      const autoplay = $player.data('video-autoplay') === true;
      const loop = $player.data('video-loop') === true;
      const mute = $player.data('video-mute') === true;
      const hideControls = $player.data('video-controls') === false;
      const videoUrl = videoUrlHls || videoUrlProgressive;

      setupVideoPlayer(playerId, {
        playlist: [{
          file: videoUrl,
          image: posterImage,
          title: videoName,
          description: ''
        }],
        autostart: autoplay,
        repeat: loop,
        mute: mute,
        controls: !hideControls,
        ga4analytics: true
      });
    });
  }

  /**
   * Initializes a player whose setup was deferred until its carousel initialized.
   * @param {HTMLElement} player - The inline player placeholder.
   * @param {Number} index - Index used when assigning a fallback element id.
   * @returns {Object|Boolean} JW Player instance, or false when setup is unavailable.
   */
  static initDeferredPlayer(player, index = 0) {
    const $player = $(player);

    if (!$player.length || $player.data('video-player-initialized')) {
      return false;
    }

    const setup = window.setupVideoPlayer;

    if (typeof setup !== 'function') {
      return false;
    }

    let playerId = $player.attr('id');

    if (!playerId) {
      let candidate = index;
      do {
        playerId = 'video-player-' + candidate;
        candidate++;
      } while (document.getElementById(playerId));

      $player.attr('id', playerId);
    }

    const videoUrlHls = $player.data('video-url-hls');
    const videoUrlProgressive = $player.data('video-url-progressive');
    const videoUrl = videoUrlHls || videoUrlProgressive;

    if (!videoUrl) {
      return false;
    }

    const $container = $player.closest('.inline-video-container');
    const $bgImage = $container.find('.video-player-bg-image');
    const srcset = $bgImage.attr('data-srcset') || $bgImage.attr('srcset') || '';
    const posterImage = srcset ? srcset.split(',')[0].trim().split(/\s+/)[0] : '';
    const videoName = $player.data('video-name') || '';
    const autoplay = $player.data('video-autoplay') === true;
    const loop = $player.data('video-loop') === true;
    const mute = $player.data('video-mute') === true;
    const hideControls = $player.data('video-controls') === false;
    const playerInstance = setup(playerId, {
      playlist: [{
        file: videoUrl,
        image: posterImage,
        title: videoName,
        description: ''
      }],
      autostart: autoplay,
      repeat: loop,
      mute: mute,
      controls: !hideControls,
      ga4analytics: true
    });

    $player
      .data('video-player-initialized', true)
      .removeClass('video-player-init-disabled')
      .addClass('video-player');

    return playerInstance;
  }
}
